export default __webpack_public_path__ + "static/media/card-blog1.d292fd77.jpg";